import Vue from 'vue';
import * as _ from 'lodash';
import * as queryString from 'query-string';
import MonthTranslations from '../translations/months';
import { ApplicationConstants } from '../applicationConstants';
import textversionjs from 'textversionjs';
export class SharedService {
    static dateFormat(dateText) {
        return dateText
            ? new Date(dateText).toLocaleDateString()
            : '';
    }
    static dateDay(dateText) {
        return dateText
            ? new Date(dateText).getUTCDate()
            : '';
    }
    static dateMonth(dateText, lang) {
        const month = MonthTranslations;
        const monthNumber = dateText
            ? new Date(dateText).getUTCMonth()
            : '';
        if (monthNumber !== 0 && !monthNumber) {
            return monthNumber;
        }
        lang = lang || ApplicationConstants.defaultLanguageCode;
        const translation = month[lang]["month"]["month" + monthNumber];
        return translation;
    }
    static dateYear(dateText) {
        return dateText
            ? new Date(dateText).getUTCFullYear()
            : '';
    }
    static truncateText(text, length) {
        if (!text) {
            return '';
        }
        return (text.length > length && length !== 0)
            ? text.slice(0, length).trim() + '...'
            : text;
    }
    static truncateHtml(text, length) {
        if (!text) {
            return '';
        }
        text = textversionjs(text);
        return SharedService.truncateText(text, length);
        //text = text.replace(/\\([\s\S])|(")/g, "\\$1$2");
        //return (text.length > length && length !== 0)
        //    ? HtmlTruncate.truncate(text, length)
        //    : text;
    }
    static httpGet(url) {
        return Vue.http.get(url)
            .then((response) => {
                return response.body;
            },
                (err) => {
                    // eslint-disable-next-line
                    console.error('Err', err);
                })
            .catch((e) => {
                // eslint-disable-next-line
                console.error('Caught', e);
            });
    }
    static httpGetElements(url) {
        return Vue.http.get(url)
            .then((response) => {
                return response.body.results;
            },
                (err) => {
                    // eslint-disable-next-line
                    console.error('Err', err);
                })
            .catch((e) => {
                // eslint-disable-next-line
                console.error('Caught', e);
            });
    }
    static httpPostBody(url, formData) {
        let json = JSON.stringify(formData);
        return Vue.http.post(url, json)
            .then((response) => {
                return response;
            },
                (err) => {
                    return err;
                })
            .catch((e) => {
                return e;
            });
    }
    static httpPostCryptoUpdate(url, formData) {
        //uid: uid, token: token, userPassword: userPassword, newPassword: newPassword
        if (formData.userPassword) {
            const pass = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
            url += "&userPassword=" + window.btoa(formData.userPassword) + "&token=" + formData.token + "&uid=" + formData.uid + "&newPassword=" + window.btoa(formData.newPassword);
        } else {
            url += queryString.stringify(newForm);
        }
        //url += queryString.stringify(newForm);
        return Vue.http.post(url, {})
            .then((response) => {
                return response;
            },
                (err) => {
                    return err;
                })
            .catch((e) => {
                return e;
            });
    }
    static httpPostCrypto(url, formData) {
        /*
        const txt2 = formData.password + "###" + formData.user + "###" + formData.randomuid;
        const b643 = window.btoa(txt2);
        //atob()
        url += "&randomuid=" + b643;
        // url += queryString.stringify(formData);
        */
       // let data = {};
        if (formData.password) {
            const pass = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
            url += "&password=" + window.btoa(pass) + "&user=" + formData.user + "&randomuid=" + formData.randomuid + "&cn=" + window.btoa(formData.password);
         //   data = { "password": window.btoa(pass), "user": formData.user, "randomuid": formData.randomuid, "cn": window.btoa(formData.password) };
        } else {
            url += queryString.stringify(newForm);
        }
        //url += queryString.stringify(newForm);
        return Vue.http.post(url, {})
            .then((response) => {
                return response;
            },
                (err) => {
                    return err;
                })
            .catch((e) => {
                return e;
            });
    }
    static httpPost(url, formData) {
        url += queryString.stringify(formData);
        return Vue.http.post(url, {})
            .then((response) => {
                return response;
            },
                (err) => {
                    return err;
                })
            .catch((e) => {
                return e;
            });
    }
    static newestElement(elements) {
        return _.first(_.orderBy(elements, 'dataPublicacio', ApplicationConstants.descendingOrder));
    }
    static isRandomUser(randomuser) {
        let isRandom = false;
        if (randomuser && randomuser.indexOf('random_') !== -1) {
            isRandom = true;
        }
        return isRandom;
    }
}



// WEBPACK FOOTER //
// ./src/shared/services/sharedService.js